export enum NavbarLink {
  Home = "Home",
  SuccessStories = "Success Stories",
  Careers = "Careers",
  People = "People",
  WhoWeAre = "Who we are",
  ScheduleCall = "Schedule a call",
}

export const navbarContent = {
  logo: {
    src: "assets/H_logo_w.png",
    alt: "Hungerford Logo",
  },
  links: [
    {
      id: NavbarLink.WhoWeAre,
      label: "Who We Are",
      to: "/who-we-are",
    },
    {
      id: NavbarLink.People,
      label: "People",
      to: "/people",
    },
    { id: NavbarLink.Careers, label: "Careers", to: "/careers" },
    {
      id: NavbarLink.SuccessStories,
      label: "Success Stories",
      to: "/success-stories",
    },
    {
      id: NavbarLink.ScheduleCall,
      label: "Schedule a call",
      to: "/schedule",
      isCTA: true,
    },
  ],
};
